<!--开发者合规指引-->
<template>
    <div style="padding:10px 10px 10px 10px">
      <h1 style="text-align: center">开发者合规指引</h1>
      <p>为进一步帮助开发者提升其个人信息保护水平，提升App个人信息合规水平，特制定此合规指引，供开发者参考。<b>请开发者知悉并理解，本指引仅供开发者参考，由于立法和监管政策的变化，可能导致合规要求更新，请开发者按照最新生效的法律法规、监管政策文件或相关标准的规定执行。</b></p>
      <br>
      <p>本合规指引主要分为以下几个部分：</p>
      <br>
      <p>(一) App个人信息保护</p>
      <br>
      <p>(二) App应用商店上架</p>
      <br>
      <p>(三) SDK合规使用</p>
      <br>
      <p>(四) 开发者个人信息和数据保护承诺函</p>
      <br>
      <p>(五) 监管规定汇总</p>
      <br>
      <p>(六) 爱奇艺合规文档</p>
      <br>
      <br>
      <p>(一) App个人信息保护</p>
      <p>1.App监管检查重点及合规建议</p>
      <p>（1）违规收集个人信息</p>
      <table width = 100% border="1" cellspacing="0">
        <tr >
          <td colspan="2" width=50%><b>典型问题</b></td>
          <td><b>合规建议</b></td>
        </tr>
        <tr>
          <td>私自收集</td>
          <td>App或第三方SDK未使用隐私政策弹窗等形式向用户明示个人信息收集使用的目的、方式和范围，清晰明示并经用户同意</td>
          <td>App首次启动时，增加隐私政策弹窗，隐私政策弹窗内应当向用户展示App个人信息的处理规则的文案</td>
        </tr>
        <tr>
          <td>未征得有效同意</td>
          <td>App首次启动，在征求用户同意环节，未提供明确的同意和拒绝选项，使用“好的”、“我知道了”等无法清晰表达用户意愿的词语</td>
          <td>交互设计提供明确“同意”和“拒绝”的选项征求用户同意</td>
        </tr>
        <tr>
          <td>提前收集</td>
          <td>App首次运行，用户同意隐私政策前，存在App或第三方SDK私自收集“设备MAC地址”等设备信息或其他个人信息。</td>
          <td>用户同意弹窗后再调用系统接口获取用户信息</td>
        </tr>
        <tr>
          <td>默认勾选</td>
          <td>App注册/登录环节，设置为默认勾选/同意，未提供用户自行勾选选项</td>
          <td>注册与登录环节均需要采用勾选框方式让用户确认同意隐私政策，且勾选框不可默认勾选</td>
        </tr>
        <tr>
          <td>超范围收集</td>
          <td>App或第三方SDK收集非服务所必需的信息或所收集信息无合理应用场景</td>
          <td>确保信息收集均与服务功能相关，所涉个人信息字段均在隐私政策公示并得到用户授权</td>
        </tr>
        <tr>
          <td>静默收集</td>
          <td>App或第三方SDK在后台运行时（静默状态下）收集“设备MAC地址”等个人信息</td>
          <td>检查后台运行时（静默状态下）收集是否符合最小必要原则，如果符合， 将后台运行时（静默状态下）获取的个人信息在隐私政策中明示</td>
        </tr>
      </table>
      <br>
      <p>（2）违规使用个人信息</p>
      <table width = 100% border="1" cellspacing="0">
        <tr>
          <td colspan="2" width=50%><b>典型问题</b></td>
          <td><b>合规建议</b></td>
        </tr>
        <tr>
          <td>违规共享</td>
          <td>未经用户同意，存在将“设备MAC地址”等个人信息发送给第三方SDK的行为</td>
          <td>将使用且收集个人信息的第三方SDK在隐私政策中列出，且应当包括但不限于第三方SDK名称、公司主体、使用目的、共享的个人信息、权限使用情况、第三方SDK处理个人信息规则说明（可采用隐私以政策链接方式）</td>
        </tr>
        <tr>
          <td>强制推送</td>
          <td>存在个性化推送功能，但未见提供退出或关闭个性化展示的选项及/或关闭后，App中仍保留表明内容是个性化推荐的标签，例如“推荐”“猜你喜欢”等</td>
          <td>确认是否存在个性化推送功能，如有，应在隐私政策中说明有个性化推送功能；对于存在个性化内容推荐功能的应用应该在App内设置有效的关闭个性化的机制或选项；<br/>
              关闭个性化推荐后，App内不应出现标明“推荐” “猜你喜欢”等其他能显著区分的字样</td>
        </tr>
      </table>
      <br>
      <p>（3）App强制、频繁、过度索取权限</p>
      <table width = 100% border="1" cellspacing="0">
          <tr>
            <td colspan="2" width=50%><b>典型问题</b></td>
            <td><b>合规建议</b></td>
          </tr>
          <tr>
            <td>提前申请</td>
            <td>App首次打开或后续运行时，未见使用权限对应的相关功能或服务时，提前向用户弹窗申请开启通讯录、定位、短信、录音、相机、日历等权限</td>
            <td>App 所有权限应为触发式申请，并且在申请前明示获取权限的目的</td>
          </tr>
          <tr>
            <td>频繁申请</td>
            <td>App在用户明确拒绝位置、日历、通讯录等非必要权限申请后，重新运行时，仍向用户弹窗申请开启与当前服务场景无关的权限，影响用户正常使用</td>
            <td>明确拒绝后，48 小时内不得再次申请该权限</td>
          </tr>
          <tr>
            <td>不给权限不让用</td>
            <td>用户拒绝授予权限，App直接退出、循环弹窗向用户申请权限或无法注册登录等</td>
            <td>无论用户拒绝任何权限，App都需要向用户提供基础功能，且权限应在使用权限对应的相关功能或服务时方可申请</td>
          </tr>
          <tr>
              <td>频繁关联启动和自启动</td>
              <td>APP未向用户告知且未经用户同意，或无合理的使用场景，频繁自启动或关联启动第三方App的行为</td>
              <td>检查权限列表是否声明了RECEIVE_BOOT_COMPLETED 开机广播权限，该权限是否有合理使用场景，若有，请在隐私政策中明确具体使用目的，若无，请在 AndroidManifest.xml 文件中去掉该权限</td>
          </tr>
      </table>
      <br>
      <p>（4）为账号注销设置障碍</p>
      <table width = 100% border="1" cellspacing="0">
        <tr>
          <td colspan="2" width=50%><b>典型问题</b></td>
          <td><b>合规建议</b></td>
        </tr>
        <tr>
          <td>无注销入口</td>
          <td>App内未提供账号注销功能</td>
          <td>具有注册登录功能的App，应当在App内向用户提供账号注销功能</td>
        </tr>
        <tr>
          <td>设置注销不合理条件</td>
          <td>身份核验时要求用户再次提供的个人信息类型多于注册、使用等服务环节收集的个人信息类型 </td>
          <td>账号注销时需要用户提供的信息，不得超过用户注册及使用App期间所提供的信息</td>
        </tr>
        <tr>
          <td>无效注销</td>
          <td>注销后 15 个工作日无人处理/注销后仍然可以登录等</td>
          <td>App应在15个工作日内响应用户注销请求，且完成注销后，及时删除用户个人信息或进行匿名化处理</td>
        </tr>
      </table>
      <br>
      <p>（5）欺骗、误导强迫用户</p>
        <table width = 100% border="1" cellspacing="0">
          <tr>
            <td colspan="2" width=50%><b>典型问题</b></td>
            <td><b>合规建议</b></td>
          </tr>
          <tr>
            <td>无注销入口</td>
            <td>App内未提供账号注销功能</td>
            <td>具有注册登录功能的App，应当在App内向用户提供账号注销功能</td>
          </tr>
          <tr>
            <td>设置注销不合理条件</td>
            <td>身份核验时要求用户再次提供的个人信息类型多于注册、使用等服务环节收集的个人信息类型 </td>
            <td>账号注销时需要用户提供的信息，不得超过用户注册及使用App期间所提供的信息</td>
          </tr>
          <tr>
            <td>无效注销</td>
            <td>注销后 15 个工作日无人处理/注销后仍然可以登录等</td>
            <td>App应在15个工作日内响应用户注销请求，且完成注销后，及时删除用户个人信息或进行匿名化处理</td>
          </tr>
        </table>

      <br>
      <br>
      <p>2.App隐私政策合规要求</p>
      <p>（1）具体要求：</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;《隐私政策》应当包括以下内容：适用范围、摘要、收集使用个人信息规则、保障个人信息安全规则、保障个人信息主体权利规则、个人信息跨境流动的规则、隐私协议更新的规则等，并且提供个人信息处理者的联系方式；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;《隐私政策》应单独成文，提供“同意”或“不同意”选项，给予用户主动选择权，不得默认勾选“同意”，须用户自主选择“同意”或“不同意”；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 对于用户的权利或义务有重大影响的内容及处理的敏感信息、申请的系统敏感权限等，应进行显著告知，如采取加粗/下划线等方式；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;《隐私政策》中不应出现免除自身责任、加重用户责任、排除用户主要权利的条款；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户进入App点击4次以内就能够访问到《隐私政策》；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;需列明App与第三方的信息共享情况，包括共享的个人信息的类型和原因、个人信息的接收方、对接受方的管束和管理准则、接收方使用个人信息的目的、个人信息共享过程中的安全保护措施等；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如嵌入爱奇艺联盟SDK的，请在开发者产品与/或服务的隐私政策中，按照本指引的相关内容披露爱奇艺联盟SDK处理个人信息的规则情况，具体披露要求请参考：（三）SDK合规使用；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如果开发者产品与/或服务涉及处理儿童个人信息，应当有独立的儿童个人信息保护规则。</p>

      <br>
      <p>（2）文档参考：</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;隐私政策范本可参考《信息安全技术 个人信息安全规范》（GB/T 35273-2020）附录D</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;个人信息类型详见《信息安全技术 个人信息安全规范》（GB/T 35273-2020）附录A/B</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;系统权限详见《网络安全标准实践指南—移动互联网应用程序App系统权限申请使用指南》（TC260-PG-20204A）附录A</p>


      <br>
      <p>(二) App应用商店上架</p>
      <p>1.基础信息审核</p>
      <p>（1）根据应用分发平台的具体要求，完成真实身份信息认证，并提供有效App上架联络人员的联系方式；</p>
      <p>（2）如实登记待上架App相关信息，包括应用名称、图标、简介、版本信息、服务类型、开发运营者信息、隐私政策、权限列表信息（具体以应用商店要求为准）。上述信息务必确保真实准确，确保与用户最终下载安装的App一致；</p>
      <p>（3）应用提交的安装包应当为最终用户下载的安装包一致，不得出现更换安装包等情况。</p>

      <br>
      <p>2.资质审核</p>
      <p>App提供互联网信息服务，依法须经有关主管部门审核同意或者取得相关许可的，应经有关主管部门审核同意或者取得相关许可后，并向应用分发平台提供相关证明材料，方可进行App上架。</p>

      <br>
      <p>3.安全技术管理审查</p>
      <p>App上架前，应当符合应用商店安全审查要求，App提供者不得存在包括但不限于如下行为：</p>
      <p>（1）侵害用户权益的行为：</p>

      <p><span style="font-family:Wingdings; color:#333333"></span>网络安全方面：</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>含有病毒木马等有害程序；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>存在安全漏洞导致信息被泄露、被篡改；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>个人信息权益：</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>强制索取权限、过度索取权限、频繁申请权限；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>频繁自启动和关联启动；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>任何窃取数据、暗中监控用户、或其他损害用户利益的恶意行为；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>未向用户提供账号注销服务，或为注销服务设置不合理的障碍；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>个性化推荐服务未提供退出机制。</p>


      <br>
      <p>（2）欺骗、误导用户的行为：</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>欺骗、误导或者强迫用户下载、安装、运行、升级、卸载软件；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>基于任何目的的虚假信息制作、发布服务；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>未经提示并由用户主动选择同意，修改用户软件或硬件设置；</p>
      <p><span style="font-family:Wingdings; color:#333333"></span>未经用户主动选择同意，软件卸载后有可执行代码或者其他不必要的文件驻留在用户终端。</p>

      <br>
      <p>（3）其他可能侵害用户权益或侵犯其他App提供者合法权益的行为</p>


      <br>
      <p>  4.App内容合规审查</p>
      <p>  （1）信息内容生态治理</p>
      <p>  App禁止发布违法违规等不良信息，包括但不限于如下内容：</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>反对宪法确定的基本原则的；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>危害国家统一、主权和领土完整的；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>宣扬邪教、迷信的；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>宣扬淫秽、赌博、暴力或者教唆犯罪的；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>危害社会公德或者民族优秀文化传统的；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>有法律、行政法规和国家规定禁止的其他内容的。</p>
      <p>   （2）用户账号注册与管理</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>账号实名： App提供者为用户提供信息发布、即时通讯等服务的，应当对申请注册的用户进行基于移动电话号码、身份证件号码或者统一社会信用代码等方式的真实身份信息认证；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>账号资质核验：App提供者应当要求注册部分专业领域的内容生产者（如经济、教育、医疗卫生、司法）提供服务资质、职业资格、专业背景等相关材料进行审查，并在账号信息中加注专门标识；</p>
      <p>  <span style="font-family:Wingdings; color:#333333"></span>账号信息公示：App应当对内容生产者账号展示合理范围内的互联网用户账号的互联网协议（IP）地址归属地信息，在互联网用户公众账号信息页面，展示公众账号的运营主体、注册运营地址、内容生产类别、统一社会信用代码、有效联系方式、互联网协议（IP）地址归属地等信息。</p>


      <br/>
       <p>  5.广告合规审查</p>
       <p>  （1）显著标识及一键关闭</p>
        <p> App内发布的广告应当显著标明“广告”，与其他非广告信息相区别，使消费者能够辨明其为广告。在互联网页面以弹出等形式发布的广告，应当显著标明关闭标志，确保一键关闭，不应提供虚假、无效、标识不明显的关闭选项，不得影响用户正常使用网络。</p>
        <p> （2）开屏广告合规要求：</p>
        <p> <span style="font-family:Wingdings; color:#333333"></span>启动屏广告应当清晰、显著标明“广告”字样；</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>启动屏广告应当在广告开始展现的同时标明显著、清晰、易识别的“跳过 关闭”标志，不得延迟展示；“跳过 关闭”标志应当真实、有效，确保用户可以选择一键关闭广告； </p>
         <p><span style="font-family:Wingdings; color:#333333"></span>启动屏广告时长不应过长，鼓励使用倒计时、进度条等形式向用户明确提示广告剩余时长；</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>启动屏广告中不得以欺骗方式诱使用户点击广告内容，包括下列形式：</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>虚假更新、虚假报错、虚假清理内存、模仿系统弹窗等形式的虚假功能性提示消息；</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>虚假播放、虚假暂停等形式的虚假按钮；</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>其他以欺骗、诱导用户点击的广告形式。</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>启动屏广告中含有红包、金币、奖品等奖励内容时，应当确保合法、真实、有效，应当在广告中明示领取限制条件，确保用户按条件能够获得全部奖励内容。</p>
         <p>（3）应用下载广告合规要求：</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>应确保用户自主选择是否下载，不得未经用户主动选择静默下载；</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>应当在用户点击广告内容后通过跳转页面、弹窗页面等形式向用户展示App必要信息，包括但不限于包括应用名称、应用版本号、开发者信息、应用权限和隐私声明信息等，用户确认后才可下载；</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>广告内容应当与广告跳转、链接到的媒介上的内容保持一致或者具有直接相关性，应当指向同一市场主体或同一商品、服务，不得通过虚假或者夸大的内容欺骗或误导用户；</p>
         <p><span style="font-family:Wingdings; color:#333333"></span>广告点击后跳转至其他App时，应当在广告内容中显著标明警示语，告知用户点击将跳转至第三方应用 ，确保用户知情。</p>
         <p>（4）其他要求：</p>
        <p> <span style="font-family:Wingdings; color:#333333"></span>App内广告应提供关闭选项且不应干扰其他App或设备的功能；</p>
        <p> <span style="font-family:Wingdings; color:#333333"></span>APP内广告不应存在频繁弹出，不应影响用户的正常操作体验；</p>
        <p><span style="font-family:Wingdings; color:#333333"></span>APP不能通过抢占锁屏等方式展示广告。</p>


      <br/>
      <br/>

      <p>  (三) SDK合规使用</p>
      <p>  1.您的应用需要有独立《隐私政策》，《隐私政策》形式与内容应当符合法律法规及其他规范性文件的规定，以易于访问的方式向最终用户（即：“您的产品的最终用户”或“您的产品的最终用户”）展示，并明确清晰的方式告知最终用户处理目的、方式和范围等个人信息处理规则。App首次冷启动时，在进行任何用户个人信息处理前，以弹窗或其他合法合规方式提示最终用户仔细阅读并取得其同意。</p>
      <br/>
      <p>  2.按照要求披露爱奇艺联盟SDK接入情况，具体披露形式应当如下：</p>
      <p>  SDK名称：爱奇艺联盟SDK</p>
      <p>  第三方公司名称：北京爱奇艺科技有限公司</p>
      <p>  共享信息名称：（以实际情况为准，如下为参考）</p>
        <table width = 100% border="1" cellspacing="0">
            <tr>
              <td><b>SDK名称</b></td>
              <td width=60%><b>个人信息种类</b></td>
              <td><b>使用目的</b></td>
            </tr>
            <tr>
              <td rowspan="4">爱奇艺联盟SDK</td>
              <td>设备信息：<br/>
                  【双端】设备品牌、型号、系统版本、Mac地址，设备语言、网络类型、WiFi名称、IP地址、电池容量、物理内存、硬盘容量、系统语言、运营商信息等基础信息<br/>
                  【仅Android】CPU类型、IMEI、AndroidID<br/>
                  【仅iOS】运营商信息、开机时间、系统更新时间、磁盘容量、CPU数量、内存容量、设备名称、地区名称、时区、OpenUdid、IDFV<br/>
                  基于优化广告投放目的选择是否提供：<br/>
                  【仅Android】OAID<br/>
                  【仅iOS】IDFA
              </td>
              <td>广告投放、监测归因、反作弊</td>
            </tr>
            <tr>
              <td>应用信息：<br/>
                  【仅Android】：应用名称、包名、版本号<br/>
                  【仅iOS】：应用bundleId<br/>
                  基于广告投放优化目的选择是否提供：<br/>
                  【仅Android】应用列表信息
              </td>
              <td>广告投放、反作弊</td>
            </tr>
            <tr>
              <td>广告信息：<br/>
                  【双端】如展示、点击、转化等广告交互数据
              </td>
              <td>监测归因、广告投放统计分析、反作弊</td>
            </tr>
            <tr>
                <td>位置信息：<br/>
                    基于广告投放优化目的选择是否提供：<br/>
                    【双端】位置信息</td>
                <td>广告定向投放、反作弊</td>
            </tr>
        </table>

        <br/>
        <p>涉及权限：（以实际情况为准，如下为参考） </p>
        <p>iOS端： </p>
        <table width = 100% border="1" cellspacing="0">
            <tr>
              <td width=30%><b>权限名称</b></td>
              <td width=20%><b>是否必选</b></td>
              <td><b>使用目的</b></td>
            </tr>
            <tr>
              <td >NSUserTrackingUsageDescription<br/>
                              读取设备标识信息</td>
              <td>非必选</td>
              <td>广告投放、监测归因、反作弊</td>
            </tr>
            <tr>
              <td>NSLocationWhenInUseUsageDescription<br/>
                  仅App被使用时获取地理位置
              </td>
              <td>非必选</td>
              <td>广告定向投放、反作弊</td>
            </tr>
        </table>
        <p>Android端： </p>
        <table width = 100% border="1" cellspacing="0">
            <tr>
              <td width=30%><b>权限名称</b></td>
              <td width=20%><b>是否必选</b></td>
              <td><b>使用目的</b></td>
            </tr>
            <tr>
              <td >INTERNET<br/>
                      网络权限</td>
              <td>必选</td>
              <td>进行网络连接</td>
            </tr>
            <tr>
              <td>ACCESS_NETWORK_STATE<br/>
                获取网络状态权限
              </td>
              <td>必选</td>
              <td>检查网络状态、广告投放、反作弊</td>
            </tr>
            <tr>
              <td>REQUEST_INSTALL_PACKAGES<br/>
                  安装应用权限
              </td>
              <td>非必选</td>
              <td>广告主的应用安装</td>
            </tr>
            <tr>
              <td>ACCESS_WIFI_STATE<br/>访问WiFi状态</td>
              <td>非必选</td>
              <td>广告投放、监测归因、反作弊</td>
            </tr>
            <tr>
              <td>READ_PHONE_STATE<br/>
                  读取设备信息
              </td>
              <td>非必选</td>
              <td>获取手机状态参数与设备标识等常用设备信息，用于广告投放、监测归因、反作弊</td>
            </tr>
            <tr>
              <td>READ_EXTERNAL_STORAGE<br/>
                  读取外置存储器
              </td>
              <td>非必选</td>
              <td>应用下载、广告投放、广告素材存储</td>
            </tr>
            <tr>
              <td>WRITE_EXTERNAL_STORAGE<br/>
                  写入外置存储器
              </td>
              <td>非必选</td>
              <td>应用下载、广告投放、广告素材存储</td>
            </tr>
            <tr>
              <td>ACCESS_FINE_LOCATION <br/>ACCESS_COARSE_LOCATION<br/>
                 访问精确/粗略地理位置
              </td>
              <td>非必选</td>
              <td>广告定向投放、反作弊</td>
            </tr>
        </table>
        <br/>
        <p>使用目的：广告投放、监测归因、效果优化等与广告活动相关的使用目的</p>
        <p>使用场景：广告曝光、点击时</p>
        <p>共享方式：SDK本机采集</p>
        <p>隐私政策链接：https://union.iqiyi.com/platform/privacyPolicy</p>
        <br/>

        <p>3.您应确保App首次冷启动时，在最终用户阅读您的《隐私政策》并取得其授权同意之后，再初始化爱奇艺联盟SDK进行个人信息处理。</p>
        <p>且用户同意隐私政策前，避免动态申请涉及用户信息的敏感设备权限；用户同意隐私政策前，开发者应避免私自采集、上报用户信息（尤其注意Android ID、Mac地址、硬件序列号等不受系统权限控制的用户信息）；当您的App未向用户提供服务时，例如App在后台运行时，请勿调用爱奇艺联盟SDK进行相关服务。</p>
        <br/>

        <p>4.爱奇艺联盟SDK更新：</p>
        <p>爱奇艺联盟SDK不同版本获取的字段信息会有差异，为了保护最终用户的安全和服务的可行性，我们不断更新SDK版本以提升安全性，SDK版本更新时，我们会通过站内信、邮件等一种或多种方式告知。</p>
        <p>我们强烈建议使用1.3、1.2、1.1等旧版本的Android端开发者，将爱奇艺联盟SDK升级到最新版本；使用 v1.4.02、v1.4.01、v1.3.34、v1.3.26、v1.3.13等旧版本的iOS端开发者，请将爱奇艺联盟SDK升级到最新版本。因更新不及时产生的任何问题，由开发者自行解决并承担全部责任。</p>
        <br/>

        <p>5.爱奇艺联盟SDK权限说明：</p>
        <p>开发者接入爱奇艺联盟SDK可能将会调用到的权限以及相关代码如下，我们建议您在您的隐私协议及产品弹窗中向用户声明爱奇艺联盟SDK会获取下述权限并用于广告投放、监测归因、效果优化等与广告活动有关的使用目的（以实际情况为准）：</p>
        <br/>
        <br/>
        <p>iOS端</p>
        <p>（1）读取设备标识信息（非必选）</p>
        <p>&nbsp;<span style="color:red">NSUserTrackingUsageDescription </span></p>
        <p>&nbsp;&nbsp;用途：广告投放、监测归因、反作弊</p>
        <p>&nbsp;&nbsp;注意：iOS14以后，Apple对IDFA获取进行限制，开发者需要通过建立App Tracking Transparency框架向用户提出应用跟踪全的请求，并向用户告知使用目的。请开发者务必将以下信息配置到info.plist中：</p>
        <p>&nbsp;<span style="color:red">&lt;key&gt;NSUserTrackingUsageDescription&lt;/key&gt;</span></p>
        <p>&nbsp;&lt;string&gt;[申请获取IDFA描述]&lt;/string&gt;</p>
        <br/>
        <p>（2）仅App被使用时获取地理位置（非必选）</p>
        <p>&nbsp;<span style="color:red">NSLocationWhenInUseUsageDescription </span></p>
        <p>&nbsp;用途：广告定向投放、反作弊</p>
        <br/>
        <br/>
        <p>Android端</p>
        <p>（1）网络权限（必选）</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:red">&lt;uses-permission android:name="android.permission.INTERNET" /&gt;</span></p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用途：进行网络连接</p>
        <p>（2）获取网络状态权限（必选）</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:red">&lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" /&gt;</span></p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用途：检查网络状态、广告投放、反作弊</p>
        <p>（3）读取设备信息（非必选）</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:red">&lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;</span></p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用途：获取手机状态参数与设备标识等常用设备信息，用于广告投放、监测归因、反作弊</p>
        <p>（4）外置存储器读写权限（非必选）</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:red">&lt;uses-permission android:name="android.permission.WRITE_EXTERNAL_STORAGE" /&gt;</span></p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用途：应用下载、广告投放、广告素材存储</p>
        <p>（5）访问WIFI状态（非必选）</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:red">&lt;uses-permission android:name="android.permission.ACCESS_WIFI_STATE" /&gt;</span></p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用途：访问WIFI状态，用于广告投放、监测归因、反作弊</p>
        <p>（6）安装应用权限（非必选）</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:red">&lt;uses-permission android:name="android.permission.REQUEST_INSTALL_PACKAGES"/&gt;</span></p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用途：广告主的应用安装</p>
        <br/>
        <p>注意：爱奇艺联盟SDK不强制获取以上可选权限，即使没有获取可选权限SDK也能正常运行；获取以上权限将帮助爱奇艺联盟广告优化投放广告精准度和用户的交互体验。请开发者在合适时机申请相关权限，并在不超出业务功能实际需要的情况下调用SDK及相关权限。</p>

        <br/>

        <p>(四) 开发者个人信息和数据保护承诺函</p>
        <p>为实现双方之【广告投放】合作，我司会向贵司（“北京爱爱奇艺科技有限公司及其关联公司”）提供相关个人信息，为更好的保护个人信息，确保信息处理的合法合规性，我司现向贵司做出如下承诺。本承诺函自我方勾选同意之日起生效，且不因贵我双方签署的协议和本次合作的无效、中止、终止、解除而终止或丧失效力：</p>
        <br/>
        <p>我司在此承诺并保证：</p>
        <br/>
        <p>1.有能力履行其于本承诺函下之义务，并且该履行义务的行为不违反对其有约束力的任何适用法律、法规、规章或其他规范性文件（包括国家、行业标准，下同）（以下简称“法律法规”），亦不会侵犯任何第三方之合法权益。</p>
        <p>2.严格遵守所有适用的法律法规，按照“合法正当、目的明确、公开透明”等原则处理个人信息，处理行为不违反任何适用的法律法规及本承诺函的约定，且不违背公序良俗。</p>
        <p>3.遵守贵司以书面形式向我司提供的个人信息和数据保护政策、声明或通知；如贵司要求，我方承诺签订任何进一步有关个人信息和数据的保护协议，包括任何适用的数据安全保护协议，或采取贵司要求的任何其他步骤，以满足合规要求。</p>
        <p>4.我司仅基于本承诺函之目的收集、使用、提供或以其他形式处理个人信息，不超出本承诺函约定范围处理个人信息，且不利用个人信息以任何形式获取超出合作范围的利益。</p>
        <p>5.我司基于本承诺函收集的个人信息，为实现本承诺函之目的最小必要范围，不收集任何与此承诺函之目的无关的非必要信息。</p>
        <p>6.涉及SDK接入的，我司知悉并认可爱奇艺联盟SDK具备收集个人信息的功能，并认可该等信息的收集均为双方合作之必要目的所需。</p>
        <p>7.我司已认真阅读并理解爱奇艺联盟媒体服务平台的用户协议、隐私政策及应用管理平台开发者合规指引等文档，并在遵守相关文档的前提下，进行本次合作。</p>
        <p>8.在双方订立合作协议前，贵司有权对我司进行数据合规尽职调查的风险评估，并审查我司所提供的关于所共享的个人信息的合法来源证明及相关文件，以及官网公开的用户协议与隐私政策，如贵司发现我司存在不合规的情形，则贵司有权要求我司修订用户协议与隐私政策的内容或完善相应的授权机制及其他合规机制。我司在爱奇艺联盟媒体服务平台用户协议、隐私政策、开发者合规指引下的全部义务、责任不因本条款下的贵司的风险评估权利而构成任何形式的豁免，我司仍应根据上述内容履行相应义务并承担法律责任。</p>
        <p>9.我司针对本承诺函之目的收集、使用、提供或者以其他形式处理个人信息的行为，已经获得个人信息主体及其他相关授权方的有效同意，符合与前述主体约定之目的。</p>
        <p>10.向贵司提供的信息来源合法合规，已经获得个人信息主体及其他相关授权方的有效同意，不存在任何以窃取或其他非法方式获取信息的行为。</p>
        <p>11.向贵司提供的相关个人信息，均未超出我方获取前述信息、或基于前述信息提供相关服务所需的必要存储期限，因本承诺函之目的而需对前述信息进行的处理亦未超出上述期限。同时，在相关处理完成后，我司将在处理目的实现后的5个工作日内以不可恢复方式销毁或删除、匿名化处理个人信息及其所有形式的数据备份。</p>
        <p>12.保证个人信息全部存储在中华人民共和国大陆地区，不得向大陆地区外传输，亦不得允许任何境外处理行为（包括境外访问），个人信息的所有处理均在中华人民共和国大陆地区进行。</p>
        <p>13.建立严格的保密制度、采取严格的保密措施（应不低于我司为保护我司掌握的个人信息所采用的制度和措施，亦不低于合理程度）来保护本承诺函所涉个人信息，确保个人信息不受到任何篡改、损坏、丢失等。</p>
        <p>14.严格按照法律法规规定，积极响应个人信息主体的请求，并在收到相应请求后的15个工作日内完成处理。</p>
        <br/>
        <p>若我司违背上述承诺：</p>
        <p>1.无论故意或过失，应当立即停止侵害，并在第一时间采取一切必要措施防止相关用户个人信息和数据的扩散或受到进一步侵害，尽最大可能消除不利影响。</p>
        <p>2.贵司有权暂停或终止与我司的合作，并有权追究我司的违约责任，对贵司造成任何不利影响的，我司应当负责消除（如赔礼道歉、公开申明等形式，具体以贵司要求为准）。且若对用户、贵司造成任何损失的，我司应赔偿前述主体所遭受的全部损失。</p>
        <p>3.对因我司违反本承诺函而引起任何针对贵司的权利主张、诉讼、仲裁等，我司应负责应诉，并为贵司进行抗辩，或在贵司的要求下合作抗辩，以保证贵司的利益不受损害。</p>
        <br/>
        <br/>
        <p>(五) 监管规定汇总</p>
        <p>1.《APP违法违规收集使用个人信息自评估指南》</p>
        <p>2.《App违法违规收集使用个人信息行为认定方法》</p>
        <p>3.《常见类型移动互联网应用程序必要个人信息范围规定》</p>
        <p>4.《工业和信息化部关于开展纵深推进APP侵害用户权益专项整治行动的通知》（164号文）</p>
        <p>5.《信息安全技术个人信息安全规范》（GB/T 35273-2020）</p>
        <p>6.《工业和信息化部关于开展APP侵害用户权益专项整治工作的通知》（337号文）</p>
        <p>7.《中华人民共和国数据安全法》</p>
        <p>8.《中华人民共和国个人信息保护法》</p>
        <p>9.《移动互联网应用程序信息服务管理规定》（征求意见稿）</p>
        <p>10.《信息安全技术 移动互联网应用程序（App）收集个人信息基本要求》（GB/T 41391-2022）</p>
        <p>11.《网络安全标准实践指南—移动互联网应用程序App系统权限申请使用指南》（TC260-PG-20204A）</p>
        <br/>
        <br/>
        <p>(六) 爱奇艺合规文档</p>
        <p><a href="https://privacy.iqiyi.com/policies"> 1.《爱奇艺隐私政策》</a></p>
        <p><a href="https://www.iqiyi.com/user/register/protocol.html"> 2.《爱奇艺服务协议》</a></p>
        <p><a href="https://union.iqiyi.com/platform/privacyPolicy">3.《爱奇艺联盟媒体服务平台隐私政策》</a></p>
        <p><a href="https://union.iqiyi.com/platform/developerAgreement">4.《爱奇艺联盟媒体服务平台开发者协议》</a></p>
        <p><a href="https://union.iqiyi.com/platform/developerNorms">5.《开发者个人信息和数据保护承诺函》</a></p>
    </div>
</template>

<script>
export default {
    name: "DeveloperGuide"
}
</script>

<style scoped>

</style>